
























import { Component } from '@niknevis/vue-modules'
import EntitySearchSelect from '@/modules/common/entity-search/components/shared/EntitySearchSelect.vue'
import { Prop, PropSync } from 'vue-property-decorator'
import Vue from 'vue'
import { AdminDepartmentRoute } from '@/modules/department/routes/admin-department.route'

@Component({
  components: {
    EntitySearchSelect
  }
})
export default class AdminDepartmentSearch extends Vue {
  constructor(
    private readonly adminRoutes: AdminDepartmentRoute
  ) {
    super()
  }

  @PropSync('departmentId') departmentIdValue: number
  @Prop({ default: true }) clearable: boolean

  protected get route() {
    return this.adminRoutes.search()
  }
}
